import {type Theme} from '@mui/material/styles';
import {toggleButtonClasses} from '@mui/material/ToggleButton';

/**
 * Material-UI overrides based on designs and pairing
 */
export const componentOverrides = {
  MuiAlert: {
    defaultProps: {
      variant: 'outlined',
    },
  },
  MuiToggleButton: {
    defaultProps: {
      ['data-variant']: 'text',
    },
    styleOverrides: {
      root: ({theme}: {theme: Theme}) => {
        const transition = theme.transitions.create(
          ['background-color', 'border-color', 'box-shadow'],
          {
            duration: theme.transitions.duration.short,
            easing: theme.transitions.easing.easeInOut,
          },
        );
        return {
          transition,
          variants: [
            {
              props: {'data-variant': 'outlined'},
              style: {
                color: theme.palette.secondary.main,
                borderColor:
                  'color-mix(in srgb, currentColor 50%, transparent)',
                '&:hover': {
                  borderColor:
                    'color-mix(in srgb, currentColor 90%, transparent)',
                },
              },
            },
            {
              props: {'data-variant': 'text'},
              style: {
                border: 'none',
                [`&.${toggleButtonClasses.disabled}`]: {border: 'none'},
              },
            },
          ],
        };
      },
    },
  },
  MuiSlider: {
    styleOverrides: {
      markLabel: {
        top: 20,
      },
    },
  },
  MuiCardHeader: {
    styleOverrides: {
      avatar: ({theme}: {theme: Theme}) => ({
        color: (theme.vars || theme).palette.action.active,
      }),
    },
  },
};
